import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Constants } from "@constants";
import { CiudadDTO, ICiudadDTO, IPaisDTO, IRegionDTO, PaisDTO, RegionDTO } from "@DTOS";
import { map } from "rxjs/operators";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class PaisesServiceBackend {
    constructor(private httpClient: HttpClient) {}

    public async getPaises(): Promise<PaisDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<IPaisDTO[]>(`${Constants.apiURL}/countries`).pipe(
                map(response => response.map(pais => new PaisDTO(pais)))
            )
        ).catch(() => new Array<PaisDTO>());
    }

    public async getRegiones(pais: PaisDTO): Promise<RegionDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<IRegionDTO[]>(
                `${Constants.apiURL}/countries/${pais.id}/regions`
            ).pipe(
                map(response => response.map(region => new RegionDTO(region)))
            )
        ) ?? [];
    }

    public async getCiudades(pais: PaisDTO, region: RegionDTO): Promise<CiudadDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<ICiudadDTO[]>(
                `${Constants.apiURL}/countries/${pais.id}/regions/${region.id}/cities`
            ).pipe(
                map(response => response.map(ciudad => new CiudadDTO(ciudad)))
            )
        );
    }
}
